'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _VideoCameraOutlined = _interopRequireDefault(require('./lib/icons/VideoCameraOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _VideoCameraOutlined;
exports.default = _default;
module.exports = _default;